import {
  Button,
  EditOutlineIcon,
  MailAddOutlineIcon,
} from '@mr-yum/frontend-ui'
import { isEonxEnvironment } from 'components/EonX/utils'
import { UserPartsFragment } from 'lib/gql'
import React, { ReactElement, ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

interface Props {
  user?: UserPartsFragment
  showReceipt?: boolean
  openDrawer?: () => void
  customMessage?: ReactNode
  viewReceiptCTA?: ReactElement
}

export const UserMessage = ({
  user,
  showReceipt,
  openDrawer,
  customMessage,
  viewReceiptCTA,
}: Props) => {
  const email = user?.email

  return (
    <div className="text-center text-foreground">
      {showReceipt && !customMessage && (
        <div className="space-y-4 my-body-md">
          {isEonxEnvironment() ? (
            <FormattedMessage
              defaultMessage="We hope you had a great time!"
              id="e02Yuv"
            />
          ) : (
            <>
              <div>
                {email ? (
                  <FormattedMessage
                    defaultMessage="We sent your receipt to {email}"
                    id="3TzrFp"
                    values={{ email }}
                  />
                ) : (
                  <FormattedMessage
                    defaultMessage="Need a receipt? Enter your email below"
                    id="UmYPka"
                  />
                )}
              </div>

              <div className="space-x-4">
                <Button
                  type="button"
                  onClick={openDrawer}
                  variant="secondary"
                  size="sm"
                  data-testid="user-email-cta"
                  leftIcon={
                    email ? <EditOutlineIcon /> : <MailAddOutlineIcon />
                  }
                >
                  {email ? (
                    <FormattedMessage defaultMessage="Edit email" id="5PlIj8" />
                  ) : (
                    <FormattedMessage defaultMessage="Add email" id="jdpGXt" />
                  )}
                </Button>

                {viewReceiptCTA}
              </div>
            </>
          )}
        </div>
      )}

      {customMessage}
    </div>
  )
}
